import { Impression, TrackingEvent } from "../api/api-types";

export function trackEvent(
  urls?: string[],
  macros: Record<string, string> = {}
) {
  if (!urls) {
    return;
  }
  for (const url of urls) {
    let trackingUrl = url;
    for (const [key, value] of Object.entries(macros)) {
      trackingUrl = trackingUrl.replace(`[${key}]`, value);
    }

    const img = new Image();
    img.src = trackingUrl;
  }
}

export type TrackingEventsMapKey = TrackingEvent["event"] | "impression";
export type TrackingEventsMap = Map<TrackingEventsMapKey, string[]>;
export function convertTrackingEventsAndImpressionsToMap(
  trackingEvents: TrackingEvent[],
  impressions: Impression[]
) {
  const trackingEventsMap: TrackingEventsMap = new Map();
  trackingEvents.forEach(({ event, url }) => {
    const urls = trackingEventsMap.get(event) || [];
    urls.push(url);
    trackingEventsMap.set(event, urls);
  });
  trackingEventsMap.set(
    "impression",
    impressions.map(({ url }) => url)
  );
  return trackingEventsMap;
}
